import { AxiosResponse } from 'axios';
import React, { ChangeEvent, useState } from 'react';
import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Container,
  InputLabel,
  TextField
} from '@mui/material';
// eslint-disable-next-line import/no-extraneous-dependencies
import LoadingButton from '@mui/lab/LoadingButton';
import { useTranslation } from 'react-i18next';
import ChangeAccountRequest from '../../../Model/changeAccountRequest';
import { changeAccount } from '../../../api/support';
import CustomAlert, { CustomAlertType } from '../../../Components/CustomAlert';

const ChangeAccount = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);
  const [showError, setShowError] = useState<boolean>(false);
  const [errorType, setErrorType] = useState<CustomAlertType>();
  const [newAccount, setNewAccount] = useState<string>('');
  const [oldAccount, setOldAccount] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');

  const onChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
    const field = e.target.id;
    const { value } = e.target;

    switch (field) {
      case 'oldAccount': {
        setOldAccount(value);
        break;
      }
      case 'newAccount': {
        setNewAccount(value);
        break;
      }
      default:
        break;
    }
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const form = event.currentTarget;
    console.log(form, newAccount, oldAccount);
    if (form.checkValidity()) {
      const submitData: ChangeAccountRequest = {
        oldAccount: oldAccount!,
        newAccount: newAccount!
      };
      setLoading(true);

      try {
        const result: AxiosResponse = await changeAccount(submitData);
        setLoading(false);
        if (result.data.success) {
          setShowError(true);
          setErrorMessage(`Sensore aggiunto, id: ${result.data.data.id}`);
          setErrorType(CustomAlertType.INFO);
          form.reset();
        }
      } catch (reason: any) {
        setLoading(false);
        setShowError(true);
        setErrorMessage(reason.response.data.errorMessage);
        setErrorType(CustomAlertType.ERROR);
      }
    }
  };

  return (
    <Container>
      <Card sx={{ maxWidth: 600, padding: 0 }} style={{ margin: 'auto' }}>
        <CardHeader
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.125)' }}
          subheader={t('CHANGE_ACCOUNT')}
        ></CardHeader>
        <Box
          sx={{
            width: 'auto',
            maxWidth: '100%'
          }}
        >
          <form onSubmit={handleSubmit}>
            <CardContent>
              <InputLabel>{t('OLD_ACCOUNT')}</InputLabel>
              <TextField
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 }
                }}
                size="small"
                fullWidth
                id="oldAccount"
                value={oldAccount}
                onChange={onChangeValue}
              />
              <Box sx={{ height: 20 }}/>
              <InputLabel>{t('NEW_ACCOUNT')}</InputLabel>
              <TextField
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 }
                }}
                size="small"
                required
                fullWidth
                id="newAccount"
                value={newAccount}
                onChange={onChangeValue}
              />
            </CardContent>
            <CardActions>
              <LoadingButton
                loading={loading}
                variant="contained"
                style={{
                  marginLeft: 'auto',
                  marginRight: 10,
                  marginBottom: 10
                }}
                type="submit"
              >
                {t('MOVE')}
              </LoadingButton>
            </CardActions>
          </form>
        </Box>
      </Card>
      <CustomAlert
        show={showError}
        message={errorMessage}
        type={errorType}
        onClose={() => {
          setShowError(false);
          setErrorMessage('');
        }}
      />
    </Container>
  );
};

export default ChangeAccount;
